import Fade from '@material-ui/core/Fade';
import React from 'react';
import TopPage from 'v2/components/Shared/TopPage';

import useStyles from './styles';
import TransfersTable from './TransfersTable';

function TransferHistory() {
  const classes = useStyles();

  return (
    <Fade in={true} timeout={500}>
      <div className={classes.root}>
        <TopPage title='Histórico de Transferências' goBackTo='/producer/financial-statement' />
        <TransfersTable />
      </div>
    </Fade>
  );
}

export default TransferHistory;
